import React from 'react';
import Layout from '../components/Layout/Layout';
import Seo from '../components/Seo/Seo';
import CguSite from '../components/CguSite/CguSite';

const Cgu = () => {
  return (
    <Layout>
      <Seo title="COS - CGU" description="COS - CGU" />
      <CguSite />
    </Layout>
  );
};

export default Cgu;
